export const HB_PREFIX = 'hb_';
export const SESSION_SID_KEY = 'hb_sid';

export const DEFAULT_SERVER_PATH = '/iuap-ymc-server/proxy/server/';
export const REPORT_API = '/uba/collect/ubaInfo';
// export const SERVER_TIME_API = '/uba/collect/timestamp';
export const SERVER_CONFIG_API = '/iuap-ymc-agent/uba/collect/config';

// 页面开始时间
export const PAGE_START_TIME = Math.round(performance.timeOrigin || performance.timing.navigationStart);
// 'HBClick' | 'HBPageview' | 'HBError' | 'HBRequest' | 'HBPageclose'
export enum HB_EVENT_NAME {
  PAGEVIEW = 'HBPageview',
  ERROR = 'HBError',
  REQUEST = 'HBRequest',
  PAGECLOSE = 'HBPageclose',
  CLICK = 'HBClick',
  PERF = 'HBPerf',
  COUNT = 'YCount',
  YPAGEVIEW = 'YPageview',
}

// 资源类型 'xhr' | 'script' | 'link' | 'img' | 'unknown'
export enum RESOURCE_TYPE {
  XHR = 'xhr',
  SCRIPT = 'script',
  LINK = 'link',
  IMG = 'img',
  UNKNOWN = 'unknown',
}

export enum ERROR_TYPE {
  SyntaxError = 'SyntaxError', // js错误，语法错误
  TypeError = 'TypeError', // js错误，类型错误
  ReferenceError = 'ReferenceError', // js错误，引用错误
  RangeError = 'RangeError', // js错误，范围错误
  ResourceError = 'ResourceError', // 资源类错误
  HttpError = 'HttpError', // http网络类错误
  Unknown = 'Unknown', // 未知错误，兜底
  PromiseError = 'PromiseError', // 异步错误
  ConsoleError = 'ConsoleError', // console.error打印的错误
  ReactError = 'ReactError', // react类错误
}

export enum BIZ_BST {
  DONE = 1,
  INCOMPLETE = 0,
}

// 是否为再次补充上报的
export enum BIZ_BRP {
  YES = 1,
  NO = 0
}

export enum BIZOP_TYPE {
  PAGEVIEW = '00',
  CLICK = '01',
  PAGEVIEW_CLICK = '02',
  YPAGEVIEW = '03',
  // 自定义类型
  SINGLE_POINT = '99', // 单点效率
}

export const DEFAULT_TID = 'OfILGnVasW9321995342';
export const DEFAULT_APPID = 'KqXYyZzyxk9322306249';
